import { Base } from "@/types/PropTypes";
import styles from "./CalendarHeader.module.scss";
import { NextArrowIcon, PrevArrowIcon } from "@/svg";
import { ChangeMonthBtnPpops, MonthTitleProps } from "./type";

export const Wrapper: React.FC<Base> = ({ children }) => <div className={styles.wrapper}>{children}</div>;

export const MonthWrapper: React.FC<Base> = ({ children }) => <div className={styles.monthWrapper}>{children}</div>;

export const PrevMonthButton: React.FC<ChangeMonthBtnPpops> = ({ handleMonthChange, isDisable }) => (
  <button onClick={() => handleMonthChange(-1)} className={styles.changeMonthButton} type="button" disabled={isDisable}>
    <PrevArrowIcon className={styles.arrowIcon} />
  </button>
);

export const NextMonthButton: React.FC<ChangeMonthBtnPpops> = ({ handleMonthChange, isDisable }) => (
  <button onClick={() => handleMonthChange(+1)} className={styles.changeMonthButton} type="button" disabled={isDisable}>
    <NextArrowIcon className={styles.arrowIcon} />
  </button>
);

export const MonthTitle: React.FC<MonthTitleProps> = ({ day, month, year }) => (
  <p className={styles.monthTitle}>{`${month} ${day}, ${year}`}</p>
);
